<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 section" id="acknowledgment">
<h1>Acknowledgment</h1>
<p style="text-align:center;">Thanks to my lovely wife, Linda, for her immense support and thorough proofreading.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7e2dc868